import Photo from "../Images/Photo.png";
import { FaRegFileAlt } from "react-icons/fa";
import { iconStyle } from "../../components/Showcase/Showcase";

export const resume = {
    image: Photo,
    title: "My Resume",
    description: "See more about my skills & experiences",
    code: "/contact",
    preview: "https://drive.google.com/file/d/1gXGaj0biHW7tEp4MtdHoAULdLtL4GGXy/view",
    firstBtn: "Contact",
    secondBtn: "View",
    secondIcon: <FaRegFileAlt style={iconStyle} />,
    outsideWebsite: false,
    tags: [],
};
